/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API Exporter
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { WatermarkDto } from '../models';
/**
 * ObjectStorageApi - axios parameter creator
 * @export
 */
export const ObjectStorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Удалить watermark-картинку по id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectStorageControllerDeleteWatermark: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('objectStorageControllerDeleteWatermark', 'id', id)
            const localVarPath = `/object-storage/watermarks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить файл по ссылке
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectStorageControllerGetFileByName: async (filename: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('objectStorageControllerGetFileByName', 'filename', filename)
            const localVarPath = `/object-storage/getFileByName/{filename}`
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Список watermark-картинок текущего пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectStorageControllerListWatermarks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/object-storage/watermarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Загрузить watermark-картинку для текущего пользователя
         * @param {File} file Файл изображения. Допустимые типы: image/png, image/jpeg, image/webp. Максимальный размер настраивается через WATERMARK_MAX_SIZE_BYTES (по умолчанию 5 MiB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectStorageControllerUploadWatermark: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('objectStorageControllerUploadWatermark', 'file', file)
            const localVarPath = `/object-storage/watermarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObjectStorageApi - functional programming interface
 * @export
 */
export const ObjectStorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObjectStorageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Удалить watermark-картинку по id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectStorageControllerDeleteWatermark(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectStorageControllerDeleteWatermark(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectStorageApi.objectStorageControllerDeleteWatermark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить файл по ссылке
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectStorageControllerGetFileByName(filename: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectStorageControllerGetFileByName(filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectStorageApi.objectStorageControllerGetFileByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Список watermark-картинок текущего пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectStorageControllerListWatermarks(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WatermarkDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectStorageControllerListWatermarks(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectStorageApi.objectStorageControllerListWatermarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Загрузить watermark-картинку для текущего пользователя
         * @param {File} file Файл изображения. Допустимые типы: image/png, image/jpeg, image/webp. Максимальный размер настраивается через WATERMARK_MAX_SIZE_BYTES (по умолчанию 5 MiB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectStorageControllerUploadWatermark(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WatermarkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectStorageControllerUploadWatermark(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectStorageApi.objectStorageControllerUploadWatermark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObjectStorageApi - factory interface
 * @export
 */
export const ObjectStorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObjectStorageApiFp(configuration)
    return {
        /**
         * 
         * @summary Удалить watermark-картинку по id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectStorageControllerDeleteWatermark(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.objectStorageControllerDeleteWatermark(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить файл по ссылке
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectStorageControllerGetFileByName(filename: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.objectStorageControllerGetFileByName(filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Список watermark-картинок текущего пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectStorageControllerListWatermarks(options?: RawAxiosRequestConfig): AxiosPromise<Array<WatermarkDto>> {
            return localVarFp.objectStorageControllerListWatermarks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Загрузить watermark-картинку для текущего пользователя
         * @param {File} file Файл изображения. Допустимые типы: image/png, image/jpeg, image/webp. Максимальный размер настраивается через WATERMARK_MAX_SIZE_BYTES (по умолчанию 5 MiB).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectStorageControllerUploadWatermark(file: File, options?: RawAxiosRequestConfig): AxiosPromise<WatermarkDto> {
            return localVarFp.objectStorageControllerUploadWatermark(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObjectStorageApi - object-oriented interface
 * @export
 * @class ObjectStorageApi
 * @extends {BaseAPI}
 */
export class ObjectStorageApi extends BaseAPI {
    /**
     * 
     * @summary Удалить watermark-картинку по id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectStorageApi
     */
    public objectStorageControllerDeleteWatermark(id: string, options?: RawAxiosRequestConfig) {
        return ObjectStorageApiFp(this.configuration).objectStorageControllerDeleteWatermark(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить файл по ссылке
     * @param {string} filename 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectStorageApi
     */
    public objectStorageControllerGetFileByName(filename: string, options?: RawAxiosRequestConfig) {
        return ObjectStorageApiFp(this.configuration).objectStorageControllerGetFileByName(filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Список watermark-картинок текущего пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectStorageApi
     */
    public objectStorageControllerListWatermarks(options?: RawAxiosRequestConfig) {
        return ObjectStorageApiFp(this.configuration).objectStorageControllerListWatermarks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Загрузить watermark-картинку для текущего пользователя
     * @param {File} file Файл изображения. Допустимые типы: image/png, image/jpeg, image/webp. Максимальный размер настраивается через WATERMARK_MAX_SIZE_BYTES (по умолчанию 5 MiB).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ObjectStorageApi
     */
    public objectStorageControllerUploadWatermark(file: File, options?: RawAxiosRequestConfig) {
        return ObjectStorageApiFp(this.configuration).objectStorageControllerUploadWatermark(file, options).then((request) => request(this.axios, this.basePath));
    }
}

